/**
 * Whether an error's message was written for a person.
 *
 * The lab's request of 9 October 2026: a failure is explained clearly, and
 * nothing technical about the system reaches the screen. A phone on the sign
 * in page had read "FetchEvent.respondWith received an error: no-response"
 * with the address of the API, the browser's own words for a request that got
 * no answer, shown as they came.
 *
 * An error whose words are for a person says so by carrying `said: true`: the
 * server's answer, the "no answer came" of the HTTP client, and what this
 * application raises on purpose with a sentence of its own. Everything else, a
 * `TypeError`, a parser's complaint, a library's exception, is a fault of the
 * program or of the browser, and its message is for whoever reads the console.
 *
 * Read by shape and not by class, so no layer has to import another's error
 * classes to ask, and the same question can be asked in the service worker.
 */
export function isSaid(error: unknown): error is Error {
  return (
    error instanceof Error &&
    (error as { said?: unknown }).said === true &&
    error.message.trim() !== ''
  );
}
